import React, { useState, useEffect } from "react";
import "./OnionBuy.css"; // Assuming a new CSS file for spice buyer styles
import { useAuth } from "./AuthContext";
import { Link } from "react-router-dom";
import Whyglobal from "../Components/Whyglobal";
import BuyerSide from "./BuyerSidebuyer";

const ToolsBuyerssers = [
  {
    name: "Abbas Ali Nuruddin",
    email: "abbas.nuruddin@gmail.com",
    mobileNumber: "+918432352555",
    location: "Rajsamand",
    date: "04-04-2025",
    lookingFor: "Looking for bulk purchase of electrical tools and hardware.",
    productOrService: "Power Tools",
    quantity: 12000,
    unit: "pieces",
  },
  {
    name: "Ḷṳv Ṡaḧṳ",
    email: "luv.sahu@hotmail.com",
    mobileNumber: "+917389548960",
    location: "Malhar",
    date: "06-04-2025",
    lookingFor: "Require 100 high-quality hand tools for hardware shop.",
    productOrService: "Hand Tools",
    quantity: 100,
    unit: "pieces",
  },
  {
    name: "Siddharth Palrecha",
    email: "siddharth.palrecha@arihanttools.com",
    mobileNumber: "+918139969355",
    location: "Hubli",
    date: "05-04-2025",
    lookingFor: "Need durable tools in bulk for hardware distribution.",
    productOrService: "Tools",
    quantity: 11000,
    unit: "pieces",
  },
  {
    name: "Venkatesh",
    email: "venkatesh.ramajayam@gmail.com",
    mobileNumber: "+919443944691",
    location: "Krishnagiri",
    date: "02-04-2025",
    lookingFor: "Looking for bulk supply of mechanic tools.",
    productOrService: "Mechanical Tools",
    quantity: 9500,
    unit: "pieces",
  },
  {
    name: "Pradeep Mahadev Murade",
    email: "pradeep.murade@spsteel.in",
    mobileNumber: "+917559386362",
    location: "Sangli",
    date: "03-04-2025",
    lookingFor: "Bulk requirement for industrial hand tools.",
    productOrService: "Hand Tools",
    quantity: 8000,
    unit: "pieces",
  },
  {
    name: "Chintan Patel",
    email: "chintan.patel@pranami.com",
    mobileNumber: "+918320480029",
    location: "Jamnagar",
    date: "07-04-2025",
    lookingFor: "Looking for hardware tools in large quantities.",
    productOrService: "Hardware Tools",
    quantity: 8700,
    unit: "pieces",
  },
  {
    name: "Gurunambiacharya",
    email: "guruacharya.sriwelding@gmail.com",
    mobileNumber: "+916369966339",
    location: "Thithunelvelli",
    date: "01-04-2025",
    lookingFor: "Already purchased tools, may need more soon.",
    productOrService: "Welding Tools",
    quantity: 6000,
    unit: "pieces",
  },
  {
    name: "Dev Mehta",
    email: "dev.mehta@simariaelectricals.com",
    mobileNumber: "+919958313854",
    location: "Delhi",
    date: "05-04-2025",
    lookingFor: "Need 1000 electric tools for distribution.",
    productOrService: "Electric Tools",
    quantity: 1000,
    unit: "pieces",
  },
  {
    name: "Shabbir",
    email: "shabbir.toolsbuyer@gmail.com",
    mobileNumber: "+917414064552",
    location: "Nathdwara",
    date: "03-04-2025",
    lookingFor: "Looking for 100 good quality tools for resale.",
    productOrService: "Tools",
    quantity: 100,
    unit: "pieces",
  },
  {
    name: "Muzammil Ahmed",
    email: "muzammil.ahmed@gmpanel.com",
    mobileNumber: "+919686712933",
    location: "Mysore",
    date: "04-04-2025",
    lookingFor: "Bulk purchase inquiry for control panel tools.",
    productOrService: "Control Panel Tools",
    quantity: 13000,
    unit: "pieces",
  },
  {
    name: "Praveen Solanki",
    email: "praveen.solanki@sapnaenterprises.in",
    mobileNumber: "+919022223938",
    location: "Pune",
    date: "06-04-2025",
    lookingFor: "Need various hardware tools in bulk.",
    productOrService: "Hardware Tools",
    quantity: 9700,
    unit: "pieces",
  },
  {
    name: "Bala Kumar",
    email: "bala.kumar@vsrtools.com",
    mobileNumber: "+916369900810",
    location: "Udumalpet",
    date: "02-04-2025",
    lookingFor: "Need all kinds of tools for industrial supply.",
    productOrService: "Industrial Tools",
    quantity: 12000,
    unit: "pieces",
  },
  {
    name: "Saleem Tamboli",
    email: "saleem.tamboli@auratools.in",
    mobileNumber: "+919595939144",
    location: "Jalna",
    date: "05-04-2025",
    lookingFor: "Looking for different types of tools for my workshop.",
    productOrService: "Workshop Tools",
    quantity: 8600,
    unit: "pieces",
  },
];

const ToolsBuyerss = () => {
  const { userId } = useAuth();
  const [userIsPremium, setUserIsPremium] = useState(false);
  const [shownNumbers, setShownNumbers] = useState([]);
  const [leadsViewed, setLeadsViewed] = useState(0);

  useEffect(() => {
    if (!userId) return;

    // Load the viewed leads from local storage
    const storedViewedLeads =
      JSON.parse(localStorage.getItem(`spiceViewedLeads_${userId}`)) || [];
    setShownNumbers(storedViewedLeads);

    fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/getUserWithPremiumStatus/${userId}`
    )
      .then((response) => response.json())
      .then((data) => {
        setUserIsPremium(data.isPremium);
        setLeadsViewed(data.leadsViewed);
        console.log("Premium Status:", data.isPremium);
      })
      .catch((error) => {
        console.error("Error fetching user information:", error);
      });
  }, [userId]);

  const toggleNumber = async (index) => {
    if (!userIsPremium) return; // Only premium users can see numbers

    if (leadsViewed >= 25) {
      alert("You have reached the limit of 25 leads viewed per month.");
      return;
    }

    if (shownNumbers.includes(index)) return; // If already shown, do nothing

    const updatedShownNumbers = [...shownNumbers, index];
    setShownNumbers(updatedShownNumbers);

    // Update local storage
    localStorage.setItem(
      `spiceViewedLeads_${userId}`,
      JSON.stringify(updatedShownNumbers)
    );

    const buyer = ToolsBuyerssers[index]; // Get the buyer information

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/incrementLeadsViewed/${userId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            buyerName: buyer.name,
            mobileNo: buyer.mobileNumber,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setLeadsViewed(data.leadsViewed);
      } else {
        const errorData = await response.json();
        console.error("Error incrementing leads viewed:", errorData.error);
      }
    } catch (error) {
      console.error("Error incrementing leads viewed:", error.message);
    }
  };

  return (
    <>
      <div className="container">
        <ol className="breadcrumb">
          <li
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "5px 30px",
            }}
            className="breadcrumb-item"
          >
            <Link to={"/"}>Home</Link>
          </li>
          <li
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "5px -25px",
            }}
          >
            /
          </li>
          <li
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "5px 30px",
            }}
            className="breadcrumb-item active"
          >
            Fresh Leads
          </li>
        </ol>
      </div>
      <div className="containersx">
        <div style={{ width: "200px", padding: "10px" }} className="browsers">
          <h3 style={{ marginTop: "30px" }}>Browse by State</h3>
          <ul className="flt-list cust-scroll" id="state-lists">
            <li>
              <Link to="#">All India</Link>
            </li>
            <li>
              <Link to="#">Delhi</Link>
            </li>
            <li>
              <Link to="#">Maharashtra</Link>
            </li>
            <li>
              <Link to="#">Karnataka</Link>
            </li>
            <li>
              <Link to="#">West Bengal</Link>
            </li>
            <li>
              <Link to="#">Tamil Nadu</Link>
            </li>
          </ul>

          <ul style={{ marginTop: "20px" }} className="flt-list cust-scroll">
            <h3>All Category</h3>
            <li>
              <Link to="#">Cumin Seeds</Link>
            </li>
            <li>
              <Link to="#">Turmeric Powder</Link>
            </li>
            <li>
              <Link to="#">Black Pepper</Link>
            </li>
            <li>
              <Link to="#">Chili Powder</Link>
            </li>
            <li>
              <Link to="#">Coriander Seeds</Link>
            </li>
          </ul>
        </div>
        <div className="buyers">
          {ToolsBuyerssers.map((buyer, index) => (
            <div key={index} className="buyer-card">
              <h2 style={{ color: "red" }}>{buyer.lookingFor}</h2>
              <p>
                <strong>Buyer Name:</strong> {buyer.name}
              </p>
              <p>
                <strong>Quantity:</strong> {buyer.quantity} {buyer.unit}
              </p>
              <p>
                <strong>Location </strong> {buyer.location}
              </p>
              <p>
                <strong>Date:</strong> {buyer.date}
              </p>
              <p>
                <strong>Mobile No.:</strong>{" "}
                {userIsPremium
                  ? shownNumbers.includes(index)
                    ? buyer.mobileNumber
                    : "********"
                  : "********"}
              </p>
              <div style={{ display: "flex", gap: "10px" }}>
                {userIsPremium && (
                  <button
                    className="detail-btn"
                    style={{
                      padding: "5px 10px",
                      background: "#f7f1f1",
                      color: "orange",
                      borderRadius: "3px",
                      cursor: "pointer",
                    }}
                    onClick={() => toggleNumber(index)}
                  >
                    Click to see
                  </button>
                )}
              </div>
              <div className="btns-imp">
                <Link to={"/login"}>
                  <button className="detailing-btn">View More</button>
                </Link>
                <Link to={"/register-Company"}>
                  <button className="regis-btn">Register Now</button>
                </Link>
              </div>
            </div>
          ))}
        </div>
        <BuyerSide />
      </div>
      <Whyglobal />
    </>
  );
};

export default ToolsBuyerss;
